import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=607bc0ba&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=ts&"
export * from "./Editor.vue?vue&type=script&lang=ts&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=607bc0ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607bc0ba",
  null
  
)

export default component.exports